import { ERPUser } from '../auth/types';
const roleAccess:Record<ERPUser['role'],string[]>={
 super_admin:['dashboard','crm','clients','suppliers','bookings','accounting','documents','notifications','users','settings'],
 admin:['dashboard','crm','clients','suppliers','bookings','accounting','documents','notifications','users','settings'],
 manager:['dashboard','crm','clients','suppliers','bookings','documents','notifications'],
 staff:['dashboard','crm','clients','bookings','documents','notifications']
};
export function canAccessModule(user:ERPUser|null,module:string){ if(!user)return false; return roleAccess[user.role]?.includes(module)??false; }
